import * as XLSX from 'xlsx';
import { getPaymentsReport } from '../services/kollectaApi';

/**
 * Busca todas as páginas do relatório de pagamentos e baixa um .xlsx.
 * @param {{ companyId?: string }} [options] - companyId opcional (ex.: admin)
 */
export async function downloadPaymentsExcel(options = {}) {
  const { companyId } = options;
  const pageSize = 100;
  let page = 1;
  let all = [];

  while (true) {
    const { data } = await getPaymentsReport({ page, pageSize, companyId });
    const rows = data?.rows || [];
    all = all.concat(rows);
    const total = data?.total || 0;
    if (page * pageSize >= total || rows.length === 0) break;
    page += 1;
  }

  const excelRows = all.map((r) => ({
    'Número do Contrato': r.contract_number || '',
    'Nome do Devedor': r.debtor_name || '',
    'Documento': r.personal_number || '',
    'Data do Pagamento': r.payment_date_br || '',
    'Valor Pago': r.paid_amount_brl || '',
    'Parcela': r.installment_label || '1/1',
  }));

  const ws = XLSX.utils.json_to_sheet(excelRows);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Pagamentos');
  XLSX.writeFile(wb, 'pagamentos.xlsx');
}
